// Products slice for Redux Toolkit

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  autocompleteCache: {}, // Cache autocomplete results by search term
  loading: false,
  error: null
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    fetchProductsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchProductsSuccess: (state, action) => {
      state.loading = false;
      state.products = action.payload;
    },
    fetchProductsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    cacheAutocompleteResults: (state, action) => {
      const { searchTerm, results } = action.payload;
      state.autocompleteCache[searchTerm] = results;
    },
    clearAutocompleteCache: (state) => {
      state.autocompleteCache = {};
    }
  }
});

export const {
  fetchProductsStart,
  fetchProductsSuccess,
  fetchProductsFailure,
  cacheAutocompleteResults,
  clearAutocompleteCache
} = productsSlice.actions;

export default productsSlice.reducer;

// Selectors
export const selectProducts = (state) => state.products.products;
export const selectProductsLoading = (state) => state.products.loading;
export const selectAutocompleteCache = (state) => state.products.autocompleteCache;
